"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15908],{

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 6305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        "\n\n  .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8dcb9882-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 9397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n\n  .ant-table-cell {\n    padding: unset;\n    border-bottom: ",
        " !important;\n  }\n  \n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  .ant-table-tbody > tr:last-child > td {\n    border-bottom: ",
        " !important;\n  }\n\n  .ant-table-tbody > tr.ant-table-row:hover > td {\n    background-color: unset;\n  }\n\n  .ant-table-thead > tr > th {\n    background-color: ",
        ";\n    border-bottom: ",
        " !important;\n  }\n\n  .ant-table.ant-table-bordered thead > tr > th,\n  .ant-table.ant-table-bordered tbody > tr > td,\n  .ant-table.ant-table-bordered tfoot > tr > th,\n  .ant-table.ant-table-bordered tfoot > tr > td {\n    border-right: 1px solid ",
        ";\n  }\n\n  .ant-table.ant-table-bordered .ant-table-container {\n    border: 1px solid ",
        ";\n    border-right: 0;\n    border-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "rowBorder",
            "headerBorder",
            "footerBorder"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        pagination: props.pagination || false,
        rowBorder: props.rowBorder || false,
        headerBorder: props.headerBorder || false,
        footerBorder: props.footerBorder || false,
        padding: props.padding
    };
}).withConfig({
    componentId: "sc-a2e2fb52-0"
})(_templateObject(), function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var rowBorder = param.rowBorder;
    return rowBorder ? "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro) : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var footerBorder = param.footerBorder;
    return footerBorder ? "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro) : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, function(param) {
    var headerBorder = param.headerBorder;
    return headerBorder ? "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro) : "unset";
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 11913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84607);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 12px;\n      width: 12px;\n      font-size: 10px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      min-width: 38px;\n      height: 20px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  padding: 0;\n\n  height: 20px;\n  width: 20px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  cursor: pointer;\n\n  color: ",
        ";\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 20px;\n\n  box-sizing: border-box;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-84f991d8-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].chardonnay */ .Z.chardonnay + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(10), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].yellowSea */ .Z.yellowSea, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].yellowSea */ .Z.yellowSea, function(param) {
    var isSmall = param.isSmall;
    return isSmall && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}, function(param) {
    var isUma = param.isUma;
    return isUma && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
});
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 77608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ catalog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/store.ts
var store = __webpack_require__(85440);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePrice.ts
var useLivePrice = __webpack_require__(39767);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/company/Table.js
var Table = __webpack_require__(9397);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/catalog/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: solid 1px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-bottom: solid 1px ",
        ";\n  padding: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: capitalize;\n  margin-right: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  a {\n    color: inherit;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  tr > td:last-child > p {\n    padding-right: 10px;\n  }\n  .ant-table-content {\n    overflow-x: auto;\n  }\n\n  .ant-table .ant-table-container::before,\n  .ant-table .ant-table-container::after {\n    display: none;\n  }\n\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  .ant-table-content::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  .ant-table-content {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n\n  .ant-table-thead\n    > tr\n    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n    background: transparent;\n  }\n\n  .ant-table-column-sort {\n    background: transparent;\n  }\n\n  .ant-table-column-sorters {\n    padding: 0px 5px 0px 0px;\n    width: 100%;\n    display: flex;\n\n    & > span:nth-child(1) {\n      width: 100%;\n      margin-right: 1px;\n    }\n\n    .ant-table-column-sorter {\n      .ant-table-column-sorter-up.active,\n      .ant-table-column-sorter-down.active {\n        color: ",
        ";\n        display: block;\n      }\n    }\n  }\n\n  .ant-table-column-sorter {\n    visibility: hidden;\n    margin-left: 0px;\n  }\n\n  th:hover {\n    .ant-table-column-sorter {\n      visibility: visible;\n    }\n  }\n\n  .catalog-table-body-row.no-bottom-border {\n    td {\n      border-bottom-color: #ffffff !important;\n\n      P {\n        padding-left: 16px;\n      }\n    }\n  }\n\n  ",
        "\n\n  .hide-on-mobile {\n    display: none;\n\n    @media ",
        " {\n      display: table-cell;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  border-radius: 10px;\n  display: inline-block;\n  margin: 5px 10px 5px 0;\n  padding: 0 10px;\n  height: 20px\n  line-height: 18px;\n  transition: .1s;\n  font-size: 13px;\n  white-space: nowrap;\n\n  &:hover {\n    border-color: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 100px;\n  min-height: 100px;\n  position: relative;\n  :before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n  }\n  :before {\n    content: '';\n    border-radius: 50%;\n    border-top: 2px solid ",
        ";\n    border-right: 2px solid transparent;\n    animation: ",
        " 0.7s linear infinite;\n    -webkit-animation: ",
        " 0.7s linear infinite;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 45px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  background: #f2f1fe;\n  color: #8277f8;\n  border-radius: 3px;\n  border: 1px solid #8277f8;\n  width: 35px;\n  height: 18px;\n  font-size: 12px;\n  font-weight: bold;\n  margin: 0;\n  padding: 0 4.5px 0 2px;\n\n  svg {\n    height: 12px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  > * {\n    margin-left: 0 !important;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ee4a49;\n  border-radius: 2px;\n  padding: 1px 6px;\n  font-family: var(--font-regular);\n  font-size: 10px;\n  line-height: 12px;\n  color: #ee4a49;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #00AB6B;\n  color: #00AB6B;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 12px;\n  padding: 0;\n  width: 22.8px;\n  cursor: unset;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #94b041;\n  font-family: var(--font-regular);\n  font-weight: 700;\n  padding: 0 4px;\n  font-size: 12px;\n  line-height: 16.2px;\n  color: #94b041;\n  border-radius: 2px;\n  background: #f2f6e8;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  min-height: 44px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #dadada;\n  border-radius: 3px;\n  padding: 9px 10px;\n  font-family: var(--font-regular);\n  font-size: 13px;\n  line-height: 18px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border-bottom: solid 1px #dadada;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 449px;\n  border: 1px solid #dadada;\n  padding: 20px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}





var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-0"
})(_templateObject());
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-1"
})(_templateObject1(), color/* default.gainsboro */.Z.gainsboro);
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-2"
})(_templateObject2(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);
var HeaderTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h1",
    size: "36px",
    family: "bold"
}).withConfig({
    componentId: "sc-54305b3c-3"
})(_templateObject3());
var Th = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    p: "15px 0px 15px 20px"
}).withConfig({
    componentId: "sc-54305b3c-4"
})(_templateObject4());
var Td = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function(props) {
    return {
        p: "0 0 0 20px",
        // @ts-expect-error
        family: props.bold && "bold",
        height: "44px"
    };
}).withConfig({
    componentId: "sc-54305b3c-5"
})(_templateObject5());
var styled_Table = (0,styled_components_browser_esm/* default */.ZP)(Table/* default */.Z).withConfig({
    componentId: "sc-54305b3c-6"
})(_templateObject7(), color/* default.highempahis */.Z.highempahis, function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
}, device/* default.tablet */.Z.tablet);
var Chip = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-54305b3c-7"
})(_templateObject8(), color/* default.primary60% */.Z["primary60%"], color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var loadingAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject9());
var LoadingSpinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-8"
})(_templateObject10(), color/* default.veryLightGrey */.Z.veryLightGrey, loadingAnimation, loadingAnimation);
var DayTradeMultiplier = (0,styled_components_browser_esm/* default */.ZP)(Td).withConfig({
    componentId: "sc-54305b3c-9"
})(_templateObject11());
var MultiplierBadge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-54305b3c-10"
})(_templateObject12());
var BadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-11"
})(_templateObject13());
var SuspendedBadge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-54305b3c-12"
})(_templateObject14());
var NewBadge = (0,styled_components_browser_esm/* default */.ZP)(SuspendedBadge).withConfig({
    componentId: "sc-54305b3c-13"
})(_templateObject15());
var UmaBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-14"
})(_templateObject16());
var HaircutBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-15"
})(_templateObject17());
var HaircutCell = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-16"
})(_templateObject18());
var UpdateBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-17"
})(_templateObject19());
var EmptyTableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-18"
})(_templateObject20());
var PopoverInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54305b3c-19"
})(_templateObject21());


;// CONCATENATED MODULE: ./src/features/catalog/constants.ts
var SPECIAL_BOARD_ALIAS = [
    "SUSPENDED",
    "UNSUSPENDED",
    "FCA",
    "FCA-OUT",
    "UMA", 
];
var COLUMN_KEY = {
    SYMBOL: "symbol",
    SYMBOL_FCA: "symbol_fca",
    COMPANY: "company",
    MULTIPLIER: "multiplier",
    PRICE: "price",
    CHANGE: "change",
    MARKET_CAP: "marketcap",
    LIQUIDITY: "liquidity",
    YIELD: "yield",
    BID_PRICE: "bid_price",
    OFFER_PRICE: "offer_price",
    PERFORMANCE: "performance",
    COUPON: "coupon",
    NEXT_COUPON_DATE: "next_coupon_date",
    DUE_DATE: "due_Date",
    HAIRCUT: "haircut"
};
var SPECIAL_SUBSECTOR_ALIAS = {
    TRADING_LIMIT: "TRADINGLIMIT",
    FCA: "FCA",
    SUSPENDED: "SUSPENDED",
    UNSUSPENDED: "UNSUSPENDED",
    FCA_OUT: "FCA-OUT",
    UMA: "UMA"
};

// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var styled = __webpack_require__(69836);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
;// CONCATENATED MODULE: ./src/features/catalog/Badge.tsx






var Badge = function(param) {
    var notationList = param.notationList, subsectorAlias = param.subsectorAlias, symbol = param.symbol, name = param.name;
    var showExpandedNotsusBadge = subsectorAlias && subsectorAlias.toUpperCase() === SPECIAL_SUBSECTOR_ALIAS.FCA && notationList.length > 0;
    var showMinimizedNotsusBadge = subsectorAlias && subsectorAlias.toUpperCase() === SPECIAL_SUBSECTOR_ALIAS.FCA_OUT && notationList.length > 0;
    var showUma = (subsectorAlias === null || subsectorAlias === void 0 ? void 0 : subsectorAlias.toUpperCase()) === SPECIAL_SUBSECTOR_ALIAS.UMA;
    var showSuspend = (subsectorAlias === null || subsectorAlias === void 0 ? void 0 : subsectorAlias.toUpperCase()) === SPECIAL_SUBSECTOR_ALIAS.SUSPENDED;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeContainer, {
        children: [
            showExpandedNotsusBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationBadgeContainer */.Nj, {
                children: notationList.map(function(notation, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            notation.notation_code,
                            index < notationList.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/notsus-badge-dot.svg",
                                alt: ""
                            })
                        ]
                    });
                })
            }),
            showMinimizedNotsusBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: symbol,
                notation: notationList,
                uma: false,
                isModal: false,
                name: name,
                isPopover: true,
                isNotationBadges: true
            }),
            showUma && /*#__PURE__*/ (0,jsx_runtime.jsx)(UmaBadge, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "indikator notasi khusus",
                    src: "/icon/ic_uma.svg"
                })
            }),
            showSuspend && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspendedBadge, {
                children: "Suspended"
            })
        ]
    });
};
/* harmony default export */ var catalog_Badge = (Badge);

;// CONCATENATED MODULE: ./src/features/catalog/TableCatalog.tsx















var DEFAULT_KEY = {
    LAST: "last",
    PERCENT: "percent"
};
var LIVE_VALUE_KEY = {
    LAST: "lastprice",
    PERCENT: "percentage_change"
};
function TableCatalog(param) {
    var companyList = param.companyList, isLoading = param.isLoading, liveData = param.liveData, _showMultiplier = param.showMultiplier, showMultiplier = _showMultiplier === void 0 ? false : _showMultiplier, _isFRCatalog = param.isFRCatalog, isFRCatalog = _isFRCatalog === void 0 ? false : _isFRCatalog, _subsectorAlias = param.subsectorAlias, subsectorAlias = _subsectorAlias === void 0 ? null : _subsectorAlias, _tableTitle = param.tableTitle, tableTitle = _tableTitle === void 0 ? "" : _tableTitle;
    var isTradingLimitSubsector = (subsectorAlias === null || subsectorAlias === void 0 ? void 0 : subsectorAlias.toUpperCase()) === SPECIAL_SUBSECTOR_ALIAS.TRADING_LIMIT;
    var hideDefaultSortOrder = (0,react.useMemo)(function() {
        var noSortOrder = [
            SPECIAL_SUBSECTOR_ALIAS.SUSPENDED,
            SPECIAL_SUBSECTOR_ALIAS.FCA, 
        ];
        return noSortOrder.includes(subsectorAlias === null || subsectorAlias === void 0 ? void 0 : subsectorAlias.toUpperCase());
    }, [
        subsectorAlias
    ]);
    var handleChange = function() {
        if (showMultiplier) {
            (0,securities/* clevertapDayTradeSortSelected */.$V)();
        }
    };
    var cellNumbersorter = function(param) {
        var prevValue = param.prevValue, nextValue = param.nextValue, defaultValueKey = param.defaultValueKey, liveValueKey = param.liveValueKey;
        var ref, ref1;
        var liveLastPriceA = (ref = liveData[prevValue.symbol]) === null || ref === void 0 ? void 0 : ref[liveValueKey];
        var liveLastPriceB = (ref1 = liveData[nextValue.symbol]) === null || ref1 === void 0 ? void 0 : ref1[liveValueKey];
        if (liveLastPriceA && liveLastPriceB) {
            return liveLastPriceA - liveLastPriceB;
        }
        try {
            var parsedA = parseFloat(prevValue[defaultValueKey]);
            var parsedB = parseFloat(nextValue[defaultValueKey]);
            return parsedA - parsedB;
        } catch (_err) {
            return 0;
        }
    };
    var getIgnoreSorting = function(a, b) {
        var ref, ref1, ref2, ref3;
        return ((ref = a.grouping_by) === null || ref === void 0 ? void 0 : ref.label) < ((ref1 = b.grouping_by) === null || ref1 === void 0 ? void 0 : ref1.label) || ((ref2 = a.grouping_by) === null || ref2 === void 0 ? void 0 : ref2.label) > ((ref3 = b.grouping_by) === null || ref3 === void 0 ? void 0 : ref3.label);
    };
    var getEmptyRow = function(custom_row) {
        return custom_row === "row_today" || custom_row === "row_common";
    };
    var columnValueNonFR = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                id: "catalog-table-column-company",
                children: "Company"
            }),
            key: COLUMN_KEY.COMPANY,
            dataIndex: "name",
            shouldCellUpdate: function() {
                return false;
            },
            sorter: function(a, b) {
                var ref, ref1, ref2, ref3;
                if (getIgnoreSorting(a, b)) {
                    return 0;
                }
                if (getEmptyRow(a.custom_row) || getEmptyRow(b.custom_row)) {
                    return 0;
                }
                var companyA = (a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.startsWith(" ")) ? a === null || a === void 0 ? void 0 : (ref1 = a.name) === null || ref1 === void 0 ? void 0 : ref1.substring(1) : a === null || a === void 0 ? void 0 : a.name;
                var companyB = (b === null || b === void 0 ? void 0 : (ref2 = b.name) === null || ref2 === void 0 ? void 0 : ref2.startsWith(" ")) ? b === null || b === void 0 ? void 0 : (ref3 = b.name) === null || ref3 === void 0 ? void 0 : ref3.substring(1) : b === null || b === void 0 ? void 0 : b.name;
                return companyA.localeCompare(companyB);
            },
            render: function(company, record) {
                if (getEmptyRow(record.custom_row)) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                    children: company
                });
            },
            className: "hide-on-mobile catalog-table-cell-company"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-price",
                children: "Price"
            }),
            key: COLUMN_KEY.PRICE,
            dataIndex: "last",
            sorter: function(a, b) {
                if (getIgnoreSorting(a, b)) {
                    return 0;
                }
                if (getEmptyRow(a.custom_row) || getEmptyRow(b.custom_row)) {
                    return 0;
                }
                return cellNumbersorter({
                    prevValue: a,
                    nextValue: b,
                    defaultValueKey: DEFAULT_KEY.LAST,
                    liveValueKey: LIVE_VALUE_KEY.LAST
                });
            },
            render: function(price, record) {
                var ref;
                if (getEmptyRow(record.custom_row)) return null;
                var lastPrice = price;
                var livePrice = (ref = liveData[record.symbol]) === null || ref === void 0 ? void 0 : ref.lastprice;
                if (livePrice) {
                    lastPrice = livePrice;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                    align: "right",
                    children: [
                        " ",
                        numeral_default()(lastPrice).format("0,0")
                    ]
                });
            },
            className: "catalog-table-cell-price"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-change",
                children: "Change %"
            }),
            key: COLUMN_KEY.CHANGE,
            sorter: function(a, b) {
                if (getIgnoreSorting(a, b)) {
                    return 0;
                }
                if (getEmptyRow(a.custom_row) || getEmptyRow(b.custom_row)) {
                    return 0;
                }
                return cellNumbersorter({
                    prevValue: a,
                    nextValue: b,
                    defaultValueKey: DEFAULT_KEY.PERCENT,
                    liveValueKey: LIVE_VALUE_KEY.PERCENT
                });
            },
            render: function(_, row) {
                var ref, ref1;
                if (getEmptyRow(row.custom_row)) return null;
                var textColor = color/* default.midgray */.Z.midgray;
                var livePriceChange = (ref = liveData[row.symbol]) === null || ref === void 0 ? void 0 : ref.change;
                var livePercentChange = (ref1 = liveData[row.symbol]) === null || ref1 === void 0 ? void 0 : ref1.percentage_change;
                var showLivePrice = typeof livePriceChange !== "undefined" && typeof livePercentChange !== "undefined";
                var priceChange = showLivePrice ? livePriceChange : parseInt(row.change, 10) || 0;
                if (priceChange > 0) {
                    textColor = color/* default.primary */.Z.primary;
                }
                if (priceChange < 0) {
                    textColor = color/* default.sunsetOrange */.Z.sunsetOrange;
                }
                var showedResult = "".concat(priceChange, " (").concat(priceChange > 0 ? "+" : "").concat(numeral_default()(row.percent).format("0.00"), "%)");
                if (livePriceChange && livePercentChange) {
                    showedResult = "".concat(parseFloat(livePriceChange.toFixed(2)), " (").concat(livePriceChange > 0 ? "+" : "").concat(numeral_default()(livePercentChange).format("0.00"), "%)");
                }
                if ((row === null || row === void 0 ? void 0 : row.change) === "NA") {
                    showedResult = "".concat(0, " (").concat(numeral_default()(row.percent).format("0.00"), "%)");
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    color: textColor,
                    children: showedResult
                });
            },
            className: "catalog-table-cell-change"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-marketcap",
                children: "Market Cap"
            }),
            key: COLUMN_KEY.MARKET_CAP,
            dataIndex: "marketcap",
            shouldCellUpdate: function() {
                return false;
            },
            sorter: function(a, b) {
                if (getIgnoreSorting(a, b)) {
                    return 0;
                }
                if (getEmptyRow(a.custom_row) || getEmptyRow(b.custom_row)) {
                    return 0;
                }
                return a.marketcap - b.marketcap;
            },
            render: function(cap, record) {
                if (getEmptyRow(record.custom_row)) return null;
                var defaultValue = cap === "NA" || cap === "" ? "NA" : number/* default.numberFormatter */.ZP.numberFormatter({
                    num: cap,
                    fixed: 0,
                    formatDot: false
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    children: defaultValue
                });
            },
            className: "hide-on-mobile catalog-table-cell-marketcap"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-liquidity",
                children: "Liquidity (Rp)"
            }),
            key: COLUMN_KEY.LIQUIDITY,
            dataIndex: "valuema20",
            shouldCellUpdate: function() {
                return false;
            },
            sorter: function(a, b) {
                if (getIgnoreSorting(a, b)) {
                    return 0;
                }
                if (getEmptyRow(a.custom_row) || getEmptyRow(b.custom_row)) {
                    return 0;
                }
                return a.valuema20 - b.valuema20;
            },
            render: function(liquidity, record) {
                if (getEmptyRow(record.custom_row)) return null;
                var defaultValue = liquidity === "NA" || liquidity === "" ? "NA" : number/* default.numberFormatter */.ZP.numberFormatter({
                    num: parseInt(liquidity, 10),
                    fixed: 0,
                    withThousands: true
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    children: defaultValue
                });
            },
            className: "hide-on-mobile catalog-table-cell-liquidity"
        }, 
    ];
    var columnValueFR = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-yield",
                children: "Yield"
            }),
            key: COLUMN_KEY.YIELD,
            dataIndex: "extra_attributes.fr_attributes.yield",
            sorter: function(a, b) {
                var ref, ref1;
                var yieldA = parseFloat((ref = a.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.yield);
                var yieldB = parseFloat((ref1 = b.extra_attributes.fr_attributes) === null || ref1 === void 0 ? void 0 : ref1.yield);
                return yieldA - yieldB;
            },
            render: function(_, record) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Td, {
                    align: "right",
                    children: [
                        numeral_default()((ref = record.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.yield).format("0.00"),
                        "%"
                    ]
                });
            },
            className: "catalog-table-cell-yield"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-bid-price",
                children: "Harga Beli"
            }),
            key: COLUMN_KEY.BID_PRICE,
            sorter: function(a, b) {
                var ref, ref1;
                var bidPriceA = parseFloat((ref = a.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.bid_price);
                var bidPriceB = parseFloat((ref1 = b.extra_attributes.fr_attributes) === null || ref1 === void 0 ? void 0 : ref1.bid_price);
                return bidPriceA - bidPriceB;
            },
            render: function(_, row) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Td, {
                    align: "right",
                    children: [
                        numeral_default()((ref = row.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.bid_price).format("0.00"),
                        "%"
                    ]
                });
            },
            className: "catalog-table-cell-bid-price"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-offer-price",
                children: "Harga Jual"
            }),
            key: COLUMN_KEY.OFFER_PRICE,
            dataIndex: "extra_attributes.fr_attributes.offer_price",
            shouldCellUpdate: function() {
                return false;
            },
            sorter: function(a, b) {
                var ref, ref1;
                var offerPriceA = parseFloat((ref = a.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.offer_price);
                var offerPriceB = parseFloat((ref1 = b.extra_attributes.fr_attributes) === null || ref1 === void 0 ? void 0 : ref1.offer_price);
                return offerPriceA - offerPriceB;
            },
            render: function(_, record) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Td, {
                    align: "right",
                    children: [
                        numeral_default()((ref = record.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.offer_price).format("0.00"),
                        "%"
                    ]
                });
            },
            className: "hide-on-mobile catalog-table-cell-offer-price"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-perfromance",
                children: "Performa 1Y"
            }),
            key: COLUMN_KEY.PERFORMANCE,
            dataIndex: "extra_attributes.fr_attributes.performance",
            shouldCellUpdate: function() {
                return false;
            },
            sorter: function(a, b) {
                var ref, ref1;
                var percentageA = parseFloat((ref = a.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.performance);
                var percentageB = parseFloat((ref1 = b.extra_attributes.fr_attributes) === null || ref1 === void 0 ? void 0 : ref1.performance);
                return percentageA - percentageB;
            },
            render: function(_, record) {
                var ref;
                var textColor = color/* default.midgray */.Z.midgray;
                var prefix = "";
                var numberPercentage = parseFloat((ref = record.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.performance);
                if (numberPercentage > 0) {
                    prefix = "+";
                    textColor = color/* default.primary */.Z.primary;
                }
                if (numberPercentage < 0) {
                    textColor = color/* default.sunsetOrange */.Z.sunsetOrange;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                    align: "right",
                    color: textColor,
                    children: [
                        prefix,
                        numeral_default()(numberPercentage).format("0.00"),
                        "%"
                    ]
                });
            },
            className: "hide-on-mobile catalog-table-cell-performance"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                id: "catalog-table-column-due-date",
                children: "Jatuh Tempo"
            }),
            key: COLUMN_KEY.DUE_DATE,
            dataIndex: "extra_attributes.fr_attributes.due_date",
            shouldCellUpdate: function() {
                return false;
            },
            sorter: function(a, b) {
                var ref, ref1;
                var percentageA = parseFloat((ref = a.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.due_date);
                var percentageB = parseFloat((ref1 = b.extra_attributes.fr_attributes) === null || ref1 === void 0 ? void 0 : ref1.due_date);
                return percentageA - percentageB;
            },
            render: function(_, record) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    children: moment_default()((ref = record.extra_attributes.fr_attributes) === null || ref === void 0 ? void 0 : ref.due_date).format("DD MMM YYYY")
                });
            },
            className: "hide-on-mobile catalog-table-cell-due-date"
        }, 
    ];
    var restColumn = isFRCatalog ? columnValueFR : columnValueNonFR;
    var columns = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                id: "catalog-table-column-symbol",
                children: "Symbol"
            }),
            dataIndex: "symbol",
            key: COLUMN_KEY.SYMBOL,
            defaultSortOrder: hideDefaultSortOrder ? undefined : "ascend",
            sorter: {
                compare: function(a, b) {
                    var ref;
                    if (getIgnoreSorting(a, b)) {
                        return 0;
                    }
                    if (getEmptyRow(a.custom_row) || getEmptyRow(b.custom_row)) {
                        return 0;
                    }
                    return (ref = a.symbol) === null || ref === void 0 ? void 0 : ref.localeCompare(b.symbol);
                }
            },
            render: function(symbol, record) {
                var ref;
                if (getEmptyRow(record.custom_row)) {
                    return(// @ts-expect-error
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                        bold: true,
                        style: {
                            color: "#858585"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: record.custom_label
                        })
                    }));
                }
                return(// @ts-expect-error
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                    bold: true,
                    style: {
                        display: "flex",
                        gap: 6,
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: symbol
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(catalog_Badge, {
                            symbol: symbol,
                            notationList: record.notations,
                            subsectorAlias: subsectorAlias,
                            name: record.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                            condition: ((ref = record.grouping_by) === null || ref === void 0 ? void 0 : ref.label) === "Today",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewBadge, {
                                children: "NEW"
                            })
                        })
                    ]
                }));
            },
            fixed: "left",
            className: "catalog-table-cell-symbol",
            sortDirections: [
                "ascend",
                "descend",
                undefined
            ]
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(restColumn));
    if (showMultiplier) {
        columns.splice(2, 0, {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                id: "catalog-table-column-company",
                children: "Multiplier"
            }),
            key: COLUMN_KEY.MULTIPLIER,
            dataIndex: "day_trade_info",
            sorter: function(a, b) {
                var ref, ref1;
                var multiplierA = (a === null || a === void 0 ? void 0 : (ref = a.day_trade_info) === null || ref === void 0 ? void 0 : ref.multiplier) || 0;
                var multiplierB = (b === null || b === void 0 ? void 0 : (ref1 = b.day_trade_info) === null || ref1 === void 0 ? void 0 : ref1.multiplier) || 0;
                return multiplierA - multiplierB;
            },
            shouldCellUpdate: function() {
                return false;
            },
            render: function(props) {
                var ref = props || {}, multiplier = ref.multiplier, is_show_multiplier = ref.is_show_multiplier;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayTradeMultiplier, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: is_show_multiplier,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MultiplierBadge, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    component: Icons/* LightningFilledSvg */.SY
                                }),
                                multiplier,
                                "x"
                            ]
                        })
                    })
                });
            },
            className: "catalog-table-cell-multiplier"
        });
    }
    if (isTradingLimitSubsector) {
        columns.splice(2, 0, {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                id: "catalog-table-column-haircut",
                style: {
                    paddingLeft: 0
                },
                children: "Haircut"
            }),
            dataIndex: "trading_limit_info.haircut_percentage",
            key: COLUMN_KEY.HAIRCUT,
            shouldCellUpdate: function() {
                return false;
            },
            defaultSortOrder: "ascend",
            sorter: function(a, b) {
                var ref, ref1;
                var percentageA = parseFloat((ref = a.trading_limit_info) === null || ref === void 0 ? void 0 : ref.haircut_percentage) || 0;
                var percentageB = parseFloat((ref1 = b.trading_limit_info) === null || ref1 === void 0 ? void 0 : ref1.haircut_percentage) || 0;
                return percentageA - percentageB;
            },
            render: function(value, record) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(HaircutCell, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HaircutBadge, {
                        children: (ref = record.trading_limit_info) === null || ref === void 0 ? void 0 : ref.haircut_percentage
                    })
                });
            }
        });
    }
    if (SPECIAL_BOARD_ALIAS.includes(subsectorAlias === null || subsectorAlias === void 0 ? void 0 : subsectorAlias.toUpperCase())) {
        columns.splice(4, 2);
    }
    var insertDividerRow = function() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (isFRCatalog) return data;
        var dataWithDividerRow = (0,_to_consumable_array/* default */.Z)(data);
        var hasTodaySection = false;
        var lastItemType = "";
        var effectiveDate = "";
        data.forEach(function(item, index) {
            var ref;
            var currentLabel = (ref = item.grouping_by) === null || ref === void 0 ? void 0 : ref.label;
            if (lastItemType === currentLabel) return; // Skip if same as previous
            if (currentLabel === "Today") {
                hasTodaySection = true;
                effectiveDate = item.effective_date ? moment_default()(item.effective_date).format("D MMM YY") : moment_default()().format("D MMM YY");
            } else if (hasTodaySection) {
                dataWithDividerRow.splice(index, 0, {
                    custom_row: "row_common",
                    custom_label: tableTitle
                });
            }
            lastItemType = currentLabel;
        });
        if (hasTodaySection) {
            dataWithDividerRow.unshift({
                custom_row: "row_today",
                custom_label: "".concat(tableTitle === "FCA" ? "New " : "").concat(tableTitle, " ").concat(effectiveDate)
            });
        }
        return dataWithDividerRow;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Table, {
        id: "catalog-table",
        dataSource: insertDividerRow(companyList),
        columns: columns,
        headerBorder: true,
        onChange: handleChange,
        showSorterTooltip: false,
        isLoading: isLoading,
        rowKey: "symbol",
        sortDirections: [
            "ascend",
            "descend",
            "ascend"
        ],
        rowBorder: true,
        rowClassName: function(record) {
            return (record === null || record === void 0 ? void 0 : record.custom_row) ? "catalog-table-body-row no-bottom-border" : "catalog-table-body-row";
        }
    });
}
/* harmony default export */ var catalog_TableCatalog = (/*#__PURE__*/(0,react.memo)(TableCatalog));

// EXTERNAL MODULE: ./src/features/catalog/slice.ts
var slice = __webpack_require__(62893);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/features/catalog/EmptyTable.tsx



var EmptyTable = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyTableWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/illustration/empty-table.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            })
        ]
    });
};
/* harmony default export */ var catalog_EmptyTable = (EmptyTable);

// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 1 modules
var popover = __webpack_require__(10808);
;// CONCATENATED MODULE: ./src/features/catalog/PopoverInfo.tsx





var PopoverInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverInfoContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Text */.xv, {
                children: [
                    "Daftar saham yang dapat ditransaksikan menggunakan Trading Limit dengan persentase haircut untuk setiap saham.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Semakin tinggi persentase haircut, semakin kecil nilai saham yang dianggap sebagai jaminan. Haircut 100% berarti saham tersebut tidak dapat digunakan sebagai jaminan."
                ]
            })
        }),
        destroyTooltipOnHide: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/info-circle-grey.svg",
            width: "18",
            height: "18"
        })
    });
};
/* harmony default export */ var catalog_PopoverInfo = (PopoverInfo);

;// CONCATENATED MODULE: ./src/features/catalog/index.tsx




























var FR_BONDS_SECTOR_ALIAS = "fr-bonds";
function Catalog(param) {
    var sector = param.sector, subsector = param.subsector;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)([]), symbolList = ref1[0], setSymbolList = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(slice/* selectors */.wl), subsectors = ref2.subsectors, sectors = ref2.sectors, pageTitle = ref2.pageTitle, isLoading = ref2.isLoading, companies = ref2.companies;
    var ref3 = (0,react.useState)([]), companyList = ref3[0], setCompanyList = ref3[1];
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var FRBondsNavigateTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondsNavigateTrackers;
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var livePrice = (0,store/* useOrderbookStore */.av)(function(param) {
        var liveprice = param.liveprice;
        return liveprice;
    });
    var getCatalogCompanies = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.getCompanyList */.Sz.getCompanyList({
                            sector: sector,
                            subsector: subsector,
                            isCatalog: true
                        }));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getCatalogCompanies() {
            return _ref.apply(this, arguments);
        };
    }();
    var livePriceOnMessage = (0,react.useCallback)(function(message) {
        (0,store/* setValue */.sO)({
            key: "liveprice",
            symbol: message.stockCode,
            type: "update_general_pricedata",
            value: (0,_object_spread/* default */.Z)({}, livePrice, message)
        });
    }, []);
    (0,useLivePrice/* useLivePrice */.L)(symbolList, liveprice_store_types/* LivePriceSymbolsKeyEnum.CATALOG */.j.CATALOG, "catalog", livePriceOnMessage);
    var isDayTrade = (subsector === null || subsector === void 0 ? void 0 : subsector.toLocaleLowerCase()) === "daytrade";
    var isShowDayTradeMultipler = (0,react.useMemo)(function() {
        return isDayTrade && !isUserSyariah;
    }, [
        isDayTrade,
        isUserSyariah
    ]);
    var showSubsectorList = (0,react.useMemo)(function() {
        if (subsectors.length > 0 && subsectors[0].alias1 === (0,general/* convertToSlug */.k6)(sector)) {
            return false;
        }
        if (subsectors.length === 0) {
            return false;
        }
        if (subsector) {
            return false;
        }
        return true;
    }, [
        subsectors,
        subsector
    ]);
    var handleTitle = (0,react.useMemo)(function() {
        if (subsector) {
            var subSectorFound = subsectors === null || subsectors === void 0 ? void 0 : subsectors.find(function(item) {
                return (0,general/* convertToSlug */.k6)(item.alias1) === (0,general/* convertToSlug */.k6)(subsector);
            });
            return (subSectorFound === null || subSectorFound === void 0 ? void 0 : subSectorFound.name) || subsector;
        }
        if (sector) {
            var sectorFound = sectors === null || sectors === void 0 ? void 0 : sectors.find(function(item) {
                return (0,general/* convertToSlug */.k6)(item.alias1) === (0,general/* convertToSlug */.k6)(sector);
            });
            return (sectorFound === null || sectorFound === void 0 ? void 0 : sectorFound.name) || sector;
        }
        return "";
    }, [
        subsector,
        subsectors,
        sector,
        sectors
    ]);
    var catalogPageTitle = pageTitle ? "Sektor ".concat(pageTitle) : undefined;
    var isFRCatalog = (0,general/* convertToSlug */.k6)(sector) === FR_BONDS_SECTOR_ALIAS;
    (0,react.useEffect)(function() {
        if (sector && isLoggedIn) {
            getCatalogCompanies();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        sector,
        subsector
    ]);
    // Set Company & Symbol List
    (0,react.useEffect)(function() {
        if (companies !== undefined) {
            if (sector && subsector) {
                setCompanyList(companies);
                var listSymbol = companies.map(function(company) {
                    return company.symbol;
                });
                setSymbolList(listSymbol);
            }
            if (sector && !subsector) {
                setCompanyList(companies);
                var listSymbol1 = companies.map(function(company) {
                    return company.symbol;
                });
                setSymbolList(listSymbol1);
            }
        }
        return function() {
            setCompanyList([]);
        };
    }, [
        sector,
        subsector,
        companies
    ]);
    (0,react.useEffect)(function() {
        if (isDayTrade) {
            (0,securities/* clevertapDayTradeStockListViewed */.rP)({
                sourcePage: "Company Page"
            });
        }
    }, [
        isDayTrade
    ]);
    (0,react.useEffect)(function() {
        if (isFRCatalog) {
            FRBondsNavigateTrackers.onBondPageViewed("Catalog Page");
        }
    }, [
        isFRCatalog
    ]);
    var showBanner = (0,react.useMemo)(function() {
        if (((subsector === null || subsector === void 0 ? void 0 : subsector.toUpperCase()) === SPECIAL_SUBSECTOR_ALIAS.FCA_OUT || (subsector === null || subsector === void 0 ? void 0 : subsector.toUpperCase()) === SPECIAL_SUBSECTOR_ALIAS.UNSUSPENDED) && (companyList === null || companyList === void 0 ? void 0 : companyList.length) > 0) {
            return true;
        }
        return false;
    }, [
        subsector,
        companyList.length
    ]);
    var showEmptyTable = (0,react.useMemo)(function() {
        if (companyList.length === 0 && SPECIAL_BOARD_ALIAS.includes(subsector === null || subsector === void 0 ? void 0 : subsector.toUpperCase()) && !isLoading) {
            return true;
        }
        return false;
    }, [
        companyList,
        subsector,
        isLoading
    ]);
    var isTradingLimit = (subsector === null || subsector === void 0 ? void 0 : subsector.toUpperCase()) === SPECIAL_SUBSECTOR_ALIAS.TRADING_LIMIT;
    var emptyTableText = (0,react.useMemo)(function() {
        var slugSubsector = subsector === null || subsector === void 0 ? void 0 : subsector.toUpperCase();
        if (slugSubsector === SPECIAL_SUBSECTOR_ALIAS.FCA_OUT) {
            return "Tidak ada saham keluar dari FCA hari ini";
        }
        if (slugSubsector === SPECIAL_SUBSECTOR_ALIAS.UNSUSPENDED) {
            return "Tidak ada saham Unsuspend hari ini";
        }
        if (slugSubsector === SPECIAL_SUBSECTOR_ALIAS.UMA) {
            return "Tidak ada saham UMA hari ini";
        }
        return "";
    }, [
        subsector
    ]);
    if (!sector) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: catalogPageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                        children: [
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {
                                id: "catalog-loading-spinner"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: !isLoading,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Flex */.kC, {
                                        justify: "space-between",
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Flex */.kC, {
                                                        align: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                                                                id: "catalog-title",
                                                                children: handleTitle
                                                            }),
                                                            isTradingLimit && /*#__PURE__*/ (0,jsx_runtime.jsx)(catalog_PopoverInfo, {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        id: "catalog-stock-count",
                                                        children: [
                                                            companyList.length || "0",
                                                            " Stocks"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            showBanner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UpdateBannerContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: "/icon/info-circle-grey.svg",
                                                        style: {
                                                            marginRight: 6
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: (0,html_react_parser/* default */.ZP)(sanitize_html_default()((ref = companyList[0]) === null || ref === void 0 ? void 0 : ref.label_text))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    showSubsectorList && (subsectors === null || subsectors === void 0 ? void 0 : subsectors.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/catalog/".concat(sector, "/").concat(item.alias1),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                                className: "catalog-subsector-item",
                                                children: item.name
                                            })
                                        }, item.alias1);
                                    }))
                                ]
                            })
                        ]
                    }),
                    showEmptyTable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(catalog_EmptyTable, {
                        text: emptyTableText
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(catalog_TableCatalog, {
                        companyList: companyList,
                        isLoading: isLoading,
                        liveData: livePrice,
                        showMultiplier: isShowDayTradeMultipler,
                        isFRCatalog: isFRCatalog,
                        subsectorAlias: (0,general/* convertToSlug */.k6)(subsector),
                        tableTitle: handleTitle
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var catalog = (Catalog);


/***/ }),

/***/ 62893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29172);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42227);








// APIs


// Initial state
var initialState = {
    list: {},
    subsectors: [],
    sectors: [],
    pageTitle: null,
    error: null,
    isLoading: false,
    message: "",
    companies: []
};
// Selectors
var catalog = function(state) {
    return state.catalog;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(catalog, function(cat) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cat);
});
// Action type
var CONTEXT = "@feature/catalog";
var actionType = {
    GET_COMPANY_LIST: "".concat(CONTEXT, "/GET_COMPANY_LIST"),
    GET_SECTOR_LIST: "".concat(CONTEXT, "/GET_SECTOR_LIST")
};
// Side effects
var effects = {
    getSectorList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_SECTOR_LIST, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, _data, data, error_type, error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSectorList */ .Z.getSectorList();
                case 2:
                    res = _ctx.sent;
                    if (res.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Failed to fetch sector list");
                case 5:
                    _data = res.data, data = _data.data, error_type = _data.error_type, error = _data.error, message = _data.message;
                    if (!(error_type || error)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(message);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data,
                        error: error,
                        message: message
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    getCompanyList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_LIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var sector, subsector, _isCatalog, isCatalog, getState, companies, companyListPayload, getSectors, ref, sectors, getSectorData, sectorData, getSubsector, getSubsectorData, subsectorData, companyResponse, getCompanyInSector, getCompanyInSectorData, companyRequest, listCompanyResponse, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sector = param.sector, subsector = param.subsector, _isCatalog = param.isCatalog, isCatalog = _isCatalog === void 0 ? false : _isCatalog, getState = param1.getState;
                        _ctx.prev = 1;
                        companies = [];
                        companyListPayload = {};
                        ;
                        if (sector) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Sector is required");
                    case 7:
                        ref = getState(), sectors = ref.catalog.sectors;
                        if (!(sectors.length === 0)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 11;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSectorList */ .Z.getSectorList();
                    case 11:
                        // Get sector list first
                        getSectors = _ctx.sent;
                        if (getSectors.data) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error("Attempt to get sector list failed");
                    case 14:
                        getSectorData = sectors.length > 0 ? {
                            data: sectors
                        } : getSectors === null || getSectors === void 0 ? void 0 : getSectors.data;
                        if (!getSectorData.error) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: "Error sector",
                            message: getSectorData.message
                        });
                    case 17:
                        sectorData = getSectorData.data.find(function(sc) {
                            return (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sc.alias1) === (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sector);
                        });
                        if (sectorData) {
                            _ctx.next = 20;
                            break;
                        }
                        throw new Error("Sector not found");
                    case 20:
                        _ctx.next = 22;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSubsectorList */ .Z.getSubsectorList(sectorData.id);
                    case 22:
                        getSubsector = _ctx.sent;
                        if (getSubsector.data) {
                            _ctx.next = 25;
                            break;
                        }
                        throw new Error("Attempt to get sub sector data failed");
                    case 25:
                        getSubsectorData = getSubsector.data;
                        if (!getSubsectorData.error) {
                            _ctx.next = 28;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: "Error subsector",
                            message: getSubsectorData.message
                        });
                    case 28:
                        ;
                        companyResponse = {
                            data: {
                                data: null
                            }
                        };
                        if (!subsector) {
                            _ctx.next = 44;
                            break;
                        }
                        // if subsector available in url path, we will
                        // call company list by subsector id
                        subsectorData = getSubsectorData.data.find(function(sb) {
                            return (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sb.alias1) === (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(subsector);
                        });
                        if (subsectorData) {
                            _ctx.next = 36;
                            break;
                        }
                        {
                            companyListPayload = {
                                error: "Error subsector",
                                message: "Subsector not found"
                            };
                        }
                        _ctx.next = 42;
                        break;
                    case 36:
                        _ctx.next = 38;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyList */ .Z.getCompanyList(sectorData.id, subsectorData.id);
                    case 38:
                        // Get company list based on subsector
                        companyResponse = _ctx.sent;
                        if (companyResponse.data) {
                            _ctx.next = 41;
                            break;
                        }
                        throw new Error("Attempt to get company list failed");
                    case 41:
                        companies = companyResponse.data.data;
                    case 42:
                        _ctx.next = 60;
                        break;
                    case 44:
                        if (!isCatalog) {
                            _ctx.next = 52;
                            break;
                        }
                        _ctx.next = 47;
                        return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyInSector */ .Z.getCompanyInSector(sectorData.id);
                    case 47:
                        getCompanyInSector = _ctx.sent;
                        getCompanyInSectorData = getCompanyInSector.data;
                        companies = getCompanyInSectorData.data;
                        _ctx.next = 60;
                        break;
                    case 52:
                        _ctx.next = 54;
                        return getSubsectorData.data.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(subsector) {
                                var company;
                                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return lib_api_catalog__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyList */ .Z.getCompanyList(sectorData.id, subsector.id);
                                        case 2:
                                            company = _ctx.sent;
                                            return _ctx.abrupt("return", {
                                                company: company,
                                                subsectorName: subsector.alias1
                                            });
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(subsector) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    case 54:
                        companyRequest = _ctx.sent;
                        _ctx.next = 57;
                        return Promise.all(companyRequest);
                    case 57:
                        listCompanyResponse = _ctx.sent;
                        companyResponse = {
                            data: {
                                data: []
                            }
                        };
                        listCompanyResponse.map(function(response) {
                            companyResponse.data.data.push({
                                alias: response.subsectorName,
                                data: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(response.company.data.data)
                            });
                        });
                    case 60:
                        _data = companyResponse.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 64;
                            break;
                        }
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(message || (_$error === null || _$error === void 0 ? void 0 : _$error.message), constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 64:
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            data: data,
                            message: message,
                            sector: sector,
                            sectors: getSectorData.data,
                            subsector: subsector,
                            subsectors: getSubsectorData.data,
                            companies: companies
                        }, companyListPayload));
                    case 67:
                        _ctx.prev = 67;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 71:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    67
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    updateList: function(state, action) {
        var newList = {};
        var _payload = action.payload, symbol = _payload.index, data = _payload.data;
        Object.keys(state.list).map(function(key1) {
            newList[key1] = {};
            Object.keys(state.list[key1]).map(function(key2) {
                newList[key1][key2] = [];
                var values = state.list[key1][key2];
                values.map(function(value) {
                    if (value.symbol === symbol) {
                        newList[key1][key2].push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, value), {
                            last: data.lastprice,
                            change: data.change,
                            percent: data.percentage_change
                        }));
                    } else {
                        newList[key1][key2].push(value);
                    }
                });
            });
        });
        state.list = newList;
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getCompanyList.pending, function(state, action) {
        state.error = null;
        state.isLoading = true;
        var sector = action.meta.arg.sector;
        if (!state.list[sector]) {
            state.list[sector] = {};
        }
    }).addCase(effects.getCompanyList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, sector = _payload.sector, sectors = _payload.sectors, subsector = _payload.subsector, subsectors = _payload.subsectors, companies = _payload.companies;
        if (error) {
            state.error = error;
        }
        if (sectors && sector && !subsector) {
            state.sectors = sectors;
            var activeSector = sectors.find(function(item) {
                return (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(item === null || item === void 0 ? void 0 : item.alias1) === (0,utils_general__WEBPACK_IMPORTED_MODULE_4__/* .convertToSlug */ .k6)(sector);
            });
            state.pageTitle = (activeSector === null || activeSector === void 0 ? void 0 : activeSector.name) || null;
            if (data) {
                data.map(function(item) {
                    state.list[sector][item.alias] = item.data;
                });
            }
        }
        if (subsectors) {
            state.subsectors = subsectors;
            if (subsector) {
                state.list[sector][subsector] = data;
            }
        }
        state.companies = companies;
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getCompanyList.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    })// Get sector list
    .addCase(effects.getSectorList.pending, function(state) {
        state.isLoading = true;
        state.error = false;
    }).addCase(effects.getSectorList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
            state.sectors = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getSectorList.rejected, function(state, action) {
        state.error = action.payload;
        state.isLoading = false;
    });
};
var catalogSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "catalog",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (catalogSlice);


/***/ }),

/***/ 40892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dj": function() { return /* reexport */ Icons_ChevronRightSvg; },
  "V3": function() { return /* reexport */ Icons_DropDownSvg; },
  "iD": function() { return /* reexport */ Icons_LightningBoxSvg; },
  "SY": function() { return /* reexport */ Icons_LightningFilledSvg; },
  "Sf": function() { return /* reexport */ Icons_LightningSvg; },
  "bC": function() { return /* reexport */ Icons_TimerClockSvg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningSvg.tsx

var LightningSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1561_100863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5 1.25L6.75 5L9.75 6.125L4.5 11.75L5.25 8L2.25 6.875L7.5 1.25Z",
                    stroke: fill,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1561_100863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningSvg = (LightningSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningFilledSvg.tsx

var LightningFilledSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_118194)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.5 1L5 3.5L7 4.25L3.5 8L4 5.5L2 4.75L5.5 1Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_118194",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningFilledSvg = (LightningFilledSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningBoxSvg.tsx

var LightningBoxSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                stroke: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4016_142863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.75 3.625L10.125 6.75L12.625 7.6875L8.25 12.375L8.875 9.25L6.375 8.3125L10.75 3.625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4016_142863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white",
                        transform: "translate(4.5 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningBoxSvg = (LightningBoxSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/ChevronRightSvg.tsx

var ChevronRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_110905)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.51562 8.70331L7.21933 4.9996L3.51562 1.2959",
                    stroke: "#969696",
                    strokeOpacity: "0.6",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_110905",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ChevronRightSvg = (ChevronRightSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/DropDownSvg.tsx

var DropDownSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#00AB6B" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.5 6L8.5 10L12.5 6",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_DropDownSvg = (DropDownSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/TimerClockSvg.tsx

var TimerClockSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "6.00156",
                cy: "6.7252",
                r: "3.775",
                stroke: "#8277F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 4.5874V6.9624L7.1875 7.9124",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.60934",
                y1: "2.90025",
                x2: "3.457",
                y2: "1.42212",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "0.5",
                y1: "-0.5",
                x2: "2.86616",
                y2: "-0.5",
                transform: "matrix(-0.780869 -0.624695 -0.624695 0.780869 10.4688 3.60303)",
                stroke: "#8277F8",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_TimerClockSvg = (TimerClockSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/index.ts









/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 39767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useLivePrice; }
/* harmony export */ });
/* harmony import */ var _useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65131);
/* harmony import */ var _useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);


var useLivePrice = function(symbols, stateKey, actionKey, onMessage) {
    (0,_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(stateKey, symbols);
    (0,_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__/* .useLivePriceReceiver */ .V)(symbols, actionKey, onMessage);
};


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useLivePriceReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7538);





var useLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var liveprice, formattedLivePrice;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            formattedLivePrice = (0,_useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsLivePriceFormatter */ .XA)(liveprice);
                            onMessage(formattedLivePrice, liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 85440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ useOrderbookStore; },
/* harmony export */   "sO": function() { return /* binding */ setValue; }
/* harmony export */ });
/* unused harmony exports OrderbookState, setValueBatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);




var OrderbookState = {
    liveprice: {}
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(_set, _get, _store, _storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, OrderbookState);
});
var handleUpdateGeneralPriceData = function(draft, payload, isInit) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft, isInit ? payload : {}), {
        average: payload.average,
        change: payload.change,
        close: payload.close,
        frequency: payload.frequency,
        fsell: payload.fsell,
        high: payload.high,
        id: payload.id,
        lastprice: payload.lastprice,
        low: payload.low,
        open: payload.open,
        percentage_change: payload.percentage_change,
        previous: payload.previous,
        symbol: payload.symbol,
        value: payload.value,
        volume: payload.volume,
        time: payload === null || payload === void 0 ? void 0 : payload.time
    });
};
var handleUpdateOrderbookPriceData = function(draft, payload) {
    if (payload.bid) {
        draft.bid = payload.bid;
    }
    if (payload.offer) {
        draft.offer = payload.offer;
    }
    return draft;
};
var handleUpdateIepIev = function(draft, payload) {
    var ref, ref1;
    draft.iepiev = payload ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : draft.iepiev), {
        iep: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref = draft.iepiev) === null || ref === void 0 ? void 0 : ref.iep), {
            raw: payload.iep
        }),
        iev: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref1 = draft.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev), {
            raw: payload.iev
        })
    }) : null;
    return draft;
};
var TYPE_SET = {
    "update_general_pricedata_liveprice": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, false);
    },
    "update_orderbook_pricedata_liveprice": function(draft, payload) {
        return handleUpdateOrderbookPriceData(draft, payload);
    },
    "update_general_pricedata": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, true);
    },
    "update_iepiev": handleUpdateIepIev
};
var setValue = function(param) {
    var key = param.key, value = param.value, symbol = param.symbol, _type = param.type, type = _type === void 0 ? "update_general_pricedata" : _type;
    return useOrderbookStore.setState(function(state) {
        return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
            var ref;
            var draftSymbol = ((ref = draft[key]) === null || ref === void 0 ? void 0 : ref[symbol]) || {};
            draft[key][symbol] = TYPE_SET[type](draftSymbol, value);
            return;
        });
    });
};
var setValueBatch = function(payload) {
    return useOrderbookStore.setState(function(state) {
        return produce(state, function(draft) {
            payload.map(function(item) {
                var ref;
                var _payload = item.payload, value = _payload.data, index = _payload.index, type = item.name;
                var draftSymbol = ((ref = draft["liveprice"]) === null || ref === void 0 ? void 0 : ref[index]) || {};
                draft["liveprice"][index] = TYPE_SET[type](draftSymbol, value);
            });
            return draft;
        });
    });
};


/***/ }),

/***/ 92292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Notation_Content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var styled = __webpack_require__(69836);
;// CONCATENATED MODULE: ./src/global/Notation/NotationListItem.tsx



function NotationListItem(param) {
    var code = param.code, desc = param.desc, _isUma = param.isUma, isUma = _isUma === void 0 ? false : _isUma;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "space-between",
        mb: "10px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "flex-end",
                width: "44px",
                mr: "12px",
                pb: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationTag */.GU, {
                    isUma: isUma,
                    children: code
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Description */.dk, {
                children: desc
            })
        ]
    }));
}
/* harmony default export */ var Notation_NotationListItem = (NotationListItem);

;// CONCATENATED MODULE: ./src/global/Notation/Content.tsx








function Content(_param) {
    var notation = _param.notation, symbol = _param.symbol, name = _param.name, notationTag = _param.notationTag, props = (0,_object_without_properties/* default */.Z)(_param, [
        "notation",
        "symbol",
        "name",
        "notationTag"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        align: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "h1",
                        size: "20px",
                        height: "24px",
                        align: "center",
                        family: "bold",
                        children: symbol
                    }),
                    notationTag
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                py: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    align: "center",
                    children: "Perusahaan memiliki Notasi Khusus sebagai berikut:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationList */.HC, {
                direction: "column",
                align: "center",
                justify: "space-evenly",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: notation.map(function(param) {
                        var notation_code = param.notation_code, notation_desc = param.notation_desc, code = param.code, desc = param.desc;
                        return code && desc || notation_code && notation_desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_NotationListItem, {
                            code: notation_code || code,
                            desc: notation_desc || desc
                        }, "notation-".concat(code)) : null;
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var Notation_Content = (Content);


/***/ }),

/***/ 15068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69836);






var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
var UMA_ICON_URL = "/icon/ic_uma.svg";
var X_ICON_URL = "/icon/ic_x.svg";
var NOTATION_TYPE = {
    INDICATOR: "indicator",
    UMA: "uma",
    X: "x"
};
var INDICATOR_ALT_TEXT = "indikator notasi khusus";
function Notation(param) {
    var symbol = param.symbol, notation = param.notation, uma = param.uma, isModal = param.isModal, name = param.name, _isPopover = param.isPopover, isPopover = _isPopover === void 0 ? true : _isPopover, _type = param.type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _className = param.className, className = _className === void 0 ? "" : _className, _placement = param.placement, placement = _placement === void 0 ? "top" : _placement;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), visible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var isUma = type === NOTATION_TYPE.UMA && !!uma;
    var isX = type === NOTATION_TYPE.X;
    var renderTag = function(param) {
        var _type = param.// eslint-disable-next-line @typescript-eslint/no-shadow
        type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.// eslint-disable-next-line @typescript-eslint/no-shadow
        isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _src = param.src, src = _src === void 0 ? INDICATOR_ICON_URL : _src, _alt = param.alt, alt = _alt === void 0 ? INDICATOR_ALT_TEXT : _alt;
        return(// @ts-expect-error
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                alt: alt,
                src: src
            })
        }));
    };
    var renderNotation = function() {
        if (isUma) {
            return renderTag({
                type: NOTATION_TYPE.UMA,
                src: UMA_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " uma"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        if (isX) {
            return renderTag({
                type: NOTATION_TYPE.X,
                src: X_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " x"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        return renderTag({
            type: type,
            isNotationBadges: isNotationBadges
        });
    };
    var renderContent = function() {
        var isFullSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            symbol: symbol,
            uma: uma,
            notation: notation,
            name: name,
            notationTag: renderTag({
                type: NOTATION_TYPE.INDICATOR,
                isNotationBadges: true
            }),
            isFullSize: isFullSize
        });
    };
    if (isModal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function() {
                        return setVisible(true);
                    },
                    "aria-hidden": "true",
                    children: renderTag({
                        type: NOTATION_TYPE.INDICATOR,
                        isNotationBadges: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    visible: visible,
                    onCancel: onCloseModal,
                    title: null,
                    centered: true,
                    width: "500px",
                    children: renderContent(true)
                })
            ]
        });
    }
    if (!isPopover) {
        return renderNotation();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PopoverIndicator */ .H9, {
        className: className,
        content: renderContent(),
        // @ts-expect-error
        placement: placement,
        children: renderNotation()
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Notation);


/***/ }),

/***/ 69836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lw": function() { return /* binding */ BadgeLabelWrapper; },
  "W2": function() { return /* binding */ Container; },
  "dk": function() { return /* binding */ Description; },
  "CC": function() { return /* binding */ IconArrow; },
  "Qu": function() { return /* binding */ ModalIndicatorBar; },
  "L$": function() { return /* binding */ MultiplierChip; },
  "cF": function() { return /* binding */ MultiplierContainer; },
  "Nj": function() { return /* binding */ NotationBadgeContainer; },
  "H_": function() { return /* binding */ NotationBar; },
  "HC": function() { return /* binding */ NotationList; },
  "MC": function() { return /* binding */ NotationPopoverContainer; },
  "GU": function() { return /* binding */ NotationTag; },
  "LA": function() { return /* binding */ PopoverBadgeContainer; },
  "H9": function() { return /* binding */ PopoverIndicator; },
  "o7": function() { return /* binding */ TradingLimitBadge; }
});

// UNUSED EXPORTS: BadgeLabelDayTrade

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/notation/Tag.js
var Tag = __webpack_require__(11913);
;// CONCATENATED MODULE: ./src/@deprecated-ui/notation/index.js
// eslint-disable-next-line import/prefer-default-export


// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Notation/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 36px;\n      width: 100%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 2px;\n  margin: auto;\n  padding: 20px 28px;\n  width: 350px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  font-size: 14px;\n  line-height: 15px;\n  padding-bottom: 10px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  max-height: 300px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: rgba(235, 160, 49, 0.03);\n  cursor: pointer;\n  height: 38px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: unset;\n    justify-content: center;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    text-align: center;\n    width: unset;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 20px;\n    width: 20px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    width: 22.8px;\n    cursor: unset;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    width: 12px;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-right: 0;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-bottom: 2px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: #fef4e8;\n  border: 1px solid #f5931b;\n  color: #f5931b;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  font-family: ProximaNovaBd;\n\n  ",
        "\n\n  ",
        "\n  > .notation-label__icon {\n    height: 12px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  background-color: #f5f0ff;\n  padding: 2px 4.5px 2px 2px;\n  height: 16px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ], [
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-close {\n    color: rgba(0, 0, 0, 0.43);\n\n    .ant-modal-close-x {\n      font-size: 14px;\n      height: 48px;\n      line-height: 48px;\n      width: 48px;\n\n      .ant-modal-close-icon {\n        color: rgba(0, 0, 0, 0.43);\n        height: 14px;\n        width: 14px;\n\n        > svg {\n          fill: inherit;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: unset !important;\n  min-width: 12px;\n  height: 12px;\n  gap: 2px;\n  border: 1px solid #f5931b;\n  border-radius: 2px;\n  background-color: #fef4e8;\n  padding: 0 2.5px;\n  color: #f5931b;\n  font-size: 9px;\n  line-height: normal;\n  font-family: var(--font-regular);\n  margin: 0;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 8px;\n  position: relative;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #8277f8;\n  border-radius: 2px;\n  height: 16px;\n  padding: 0 4.5px 0 2px;\n  color: #8277f8;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #94b041;\n  font-family: var(--font-regular);\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.2px;\n  color: #94b041;\n  border-radius: 2px;\n  background: #f2f6e8;\n  text-align: center;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  padding: 0 2px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 375px;\n  border: 1px solid #dadada;\n  padding: 20px;\n  border-radius: 4px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}








var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-61468579-0"
})(_templateObject1(), color/* default.light */.Z.light, // @ts-expect-error
function(param) {
    var isFullsize = param.isFullsize;
    return isFullsize && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-61468579-1"
})(_templateObject2(), color/* default.component */.Z.component);
var NotationList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-2"
})(_templateObject3());
var NotationBar = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-61468579-3"
})(_templateObject4());
var notationTagVariant = {
    indicator: (0,styled_components_browser_esm/* css */.iv)(_templateObject5()),
    notation: (0,styled_components_browser_esm/* css */.iv)(_templateObject6()),
    uma: (0,styled_components_browser_esm/* css */.iv)(_templateObject7()),
    x: (0,styled_components_browser_esm/* css */.iv)(_templateObject8())
};
var NotationTag = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-61468579-4"
})(_templateObject11(), // @ts-expect-error
function(param) {
    var type = param.type;
    return notationTagVariant[type];
}, // @ts-expect-error
function(param) {
    var isNotationBadges = param.isNotationBadges;
    return isNotationBadges ? (0,styled_components_browser_esm/* css */.iv)(_templateObject9()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
});
var BadgeLabelWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center",
    px: "5px",
    py: "2px",
    ml: "5px"
}).withConfig({
    componentId: "sc-61468579-5"
})(_templateObject12(), color/* default.primary */.Z.primary);
var BadgeLabelDayTrade = (0,styled_components_browser_esm/* default */.ZP)(BadgeLabelWrapper).withConfig({
    componentId: "sc-61468579-6"
})(_templateObject13());
var IconArrow = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* default */.Z).withConfig({
    componentId: "sc-61468579-7"
})(_templateObject14(), color/* default.yellowSea */.Z.yellowSea, color/* default.yellowSea */.Z.yellowSea);
var ModalIndicatorBar = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).attrs({
    maskStyle: {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
}).withConfig({
    componentId: "sc-61468579-8"
})(_templateObject15());
var PopoverIndicator = (0,styled_components_browser_esm/* default */.ZP)(Popover/* default */.ZP).attrs({
    overlayInnerStyle: {
        border: "1px solid ".concat(color/* default.gainsboro */.Z.gainsboro)
    }
}).withConfig({
    componentId: "sc-61468579-9"
})(_templateObject16());
var NotationBadgeContainer = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-61468579-10"
})(_templateObject17());
var NotationPopoverContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-11"
})(_templateObject18());
var MultiplierContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-12"
})(_templateObject19());
var MultiplierChip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-13"
})(_templateObject20());
var TradingLimitBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-14"
})(_templateObject21());
var PopoverBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-15"
})(_templateObject22());



/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 29735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondsAnalytics; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);



var EVENTS_NAMES = {
    bondsPageViewed: "FR Bonds Page Viewed",
    bondProductPageViewed: "FR Bonds Product Page Viewed",
    bondOrderPageViewed: "FR Bonds Order Page Viewed",
    bondPreviewOrderViewed: "FR Bonds Preview Order Viewed",
    bondOrderSuccessViewed: "FR Bonds Order Success Viewed",
    bondsAction: "FR Bonds Action"
};
var PAGE_NAMES = {
    "/stream": "Stream Page",
    "/symbol": "Product Page",
    "/securities": "Portofolio List",
    "/watchlist": "Watchlist Page",
    "/screener": "Screener Page",
    "/valuation": "Valuation Page",
    "/sector": "Sector Page",
    "/community": "Community Page"
};
function useBondsAnalytics() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // fill the search related page
    var defaultPageSource = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var pageNames = Object.keys(PAGE_NAMES);
        var pageIndex = pageNames.find(function(path) {
            return router.pathname.startsWith(path) ? path : undefined;
        });
        if (pageIndex) {
            return PAGE_NAMES[pageIndex];
        }
        return "Search Page";
    }, [
        router.pathname
    ]);
    var FRBondsNavigateTrackers = {
        // When user landing on FR Bonds page
        onBondPageViewed: function onBondPageViewed(section) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsPageViewed, {
                Section: section
            });
        },
        // When user landing on FR Bonds Product page
        onBondProductPageViewed: function onBondProductPageViewed(symbol, yieldValue) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondProductPageViewed, {
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order page
        onBondOrderPageViewed: function onBondOrderPageViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderPageViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Preview Order page
        onBondPreviewOrderViewed: function onBondPreviewOrderViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondPreviewOrderViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order Success page
        onBondOrderSuccessViewed: function onBondOrderSuccessViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderSuccessViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    var FRBondActionTrackers = {
        // When user click FR Bonds introduction banner
        onIntroductionBannerClicked: function onIntroductionBannerClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "Introduction Banner Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click “Saya Setuju” on FR Bonds TnC
        onTnCConfirmed: function onTnCConfirmed() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "TnC Confirmed"
            });
        },
        // When user click FR Bonds Section/Catalog to be redirected to FR Bonds list
        onFRProductListClicked: function onFRProductListClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Product List Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click buy/sell button on FR product to initiate order
        onOrderButtonClicked: function onOrderButtonClicked(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Button Clicked",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page to finalize order
        onOrderPlaced: function onOrderPlaced(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Placed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page, confirming the order
        onOrderConfirmed: function onOrderConfirmed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Confirmed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    return {
        FRBondsNavigateTrackers: FRBondsNavigateTrackers,
        FRBondActionTrackers: FRBondActionTrackers
    };
};


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 66940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsUserSyariah; }
});

// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/auth.ts
var AccountTypeEnum;
(function(AccountTypeEnum) {
    AccountTypeEnum["EQUITY"] = "ACCOUNT_TYPE_EQUITY";
    AccountTypeEnum["SYARIAH"] = "ACCOUNT_TYPE_SYARIAH";
    AccountTypeEnum["BOND"] = "ACCOUNT_TYPE_BOND";
    AccountTypeEnum["DAY_TRADING"] = "ACCOUNT_TYPE_DAY_TRADING";
})(AccountTypeEnum || (AccountTypeEnum = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts


var useIsSyariahUser = function() {
    var accountType = securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType;
    return accountType === AccountTypeEnum.SYARIAH;
};
/* harmony default export */ var useIsUserSyariah = (useIsSyariahUser);


/***/ }),

/***/ 91154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ clevertapDayTradeSortSelected; },
/* harmony export */   "$f": function() { return /* binding */ clevertapExerciseClicked; },
/* harmony export */   "$v": function() { return /* binding */ clevertapDayTradeOrderTypeSelected; },
/* harmony export */   "A2": function() { return /* binding */ clevertapBuyOrderViewed; },
/* harmony export */   "Am": function() { return /* binding */ clevertapDayTradeLeverageSelected; },
/* harmony export */   "As": function() { return /* binding */ clevertapOrderPlaced; },
/* harmony export */   "B0": function() { return /* binding */ clevertapSellOrderViewed; },
/* harmony export */   "C4": function() { return /* binding */ clevertapSetPriceAlertSelected; },
/* harmony export */   "C5": function() { return /* binding */ clevertapDayTradeTNCViewed; },
/* harmony export */   "CH": function() { return /* binding */ clevertapOrderQuantityAdjusted; },
/* harmony export */   "EQ": function() { return /* binding */ clevertapChangeStock; },
/* harmony export */   "F9": function() { return /* binding */ clevertapDayTradeSplitOrderSelected; },
/* harmony export */   "FH": function() { return /* binding */ clevertapSecuritiesTradingPinSubmitted; },
/* harmony export */   "HR": function() { return /* binding */ clevertapDayTradeActivationDismissed; },
/* harmony export */   "J2": function() { return /* binding */ clevertapOrderPreviewed; },
/* harmony export */   "L": function() { return /* binding */ clevertapDayTradeDebtRatioViewed; },
/* harmony export */   "LA": function() { return /* binding */ clevertapViewChartSelected; },
/* harmony export */   "LF": function() { return /* binding */ clevertapExerciseViewed; },
/* harmony export */   "Lx": function() { return /* binding */ clevertapPortfolioDetailExercise; },
/* harmony export */   "Nf": function() { return /* binding */ clevertapDayTradeLeverageOptionViewed; },
/* harmony export */   "Rs": function() { return /* binding */ clevertapOrderTabSelected; },
/* harmony export */   "SW": function() { return /* binding */ clevertapDayTradeDebtRatioSubmitted; },
/* harmony export */   "Sv": function() { return /* binding */ clevertapExchangeFee; },
/* harmony export */   "TD": function() { return /* binding */ clevertapDayTradeDebtRatioChipSelected; },
/* harmony export */   "Uj": function() { return /* binding */ clevertapExerciseSelected; },
/* harmony export */   "V8": function() { return /* binding */ clevertapDayTradeActivationViewed; },
/* harmony export */   "_3": function() { return /* binding */ clevertapOrderDetailAmendViewed; },
/* harmony export */   "_O": function() { return /* binding */ clevertapPortfolioCompanySell; },
/* harmony export */   "_h": function() { return /* binding */ clevertapDayTradeOrderDetailSelected; },
/* harmony export */   "bQ": function() { return /* binding */ clevertapOrderCanceled; },
/* harmony export */   "dQ": function() { return /* binding */ clevertapOrderReceived; },
/* harmony export */   "f0": function() { return /* binding */ clevertapPortfolioBuyMore; },
/* harmony export */   "fn": function() { return /* binding */ clevertapSecuritiesTradingPinViewed; },
/* harmony export */   "hA": function() { return /* binding */ clevertapOrderDetailCancelConfirmed; },
/* harmony export */   "in": function() { return /* binding */ clevertapOrderViewed; },
/* harmony export */   "jS": function() { return /* binding */ clevertapDayTradeAfterMarketViewed; },
/* harmony export */   "kt": function() { return /* binding */ clevertapOrderDetailViewed; },
/* harmony export */   "lH": function() { return /* binding */ clevertapDayTradeActivationSelected; },
/* harmony export */   "mD": function() { return /* binding */ clevertapPortfolioSell; },
/* harmony export */   "mf": function() { return /* binding */ clevertapOrderDetailCancel; },
/* harmony export */   "ng": function() { return /* binding */ clevertapSetVisibleBalance; },
/* harmony export */   "oZ": function() { return /* binding */ clevertapDayTradeLeverageActivationSelected; },
/* harmony export */   "p": function() { return /* binding */ clevertapDayTradeActivationSuccessSelected; },
/* harmony export */   "pl": function() { return /* binding */ clevertapDayTradeActivationSubmitted; },
/* harmony export */   "qj": function() { return /* binding */ clevertapPortfolioDetailViewed; },
/* harmony export */   "r8": function() { return /* binding */ clevertapAutoOrderOptionsViewed; },
/* harmony export */   "rP": function() { return /* binding */ clevertapDayTradeStockListViewed; },
/* harmony export */   "sW": function() { return /* binding */ clevertapExerciseError; },
/* harmony export */   "t3": function() { return /* binding */ clevertapDayTradeDebtRatioModalViewed; },
/* harmony export */   "tG": function() { return /* binding */ clevertapPortfolioOrderViewed; },
/* harmony export */   "v8": function() { return /* binding */ clevertapOrderDone; },
/* harmony export */   "vM": function() { return /* binding */ clevertapStockSelected; },
/* harmony export */   "xA": function() { return /* binding */ clevertapOrderDetailAmend; },
/* harmony export */   "xC": function() { return /* binding */ clevertapBuyError; },
/* harmony export */   "xh": function() { return /* binding */ clevertapOrderConfirmedSuccess; },
/* harmony export */   "xs": function() { return /* binding */ clevertapDayTradeActivationSuccessViewed; },
/* harmony export */   "y8": function() { return /* binding */ clevertapOrderConfirmed; },
/* harmony export */   "yr": function() { return /* binding */ clevertapPortfolioViewed; }
/* harmony export */ });
/* unused harmony exports generateSymbolType, clevertapTransactionOrderFailed, clevertapTransactionOrderFailedConfirmed, clevertapTransactionOrderAlert, clevertapBuyStockContinue */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42227);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29097);
/* harmony import */ var _virtualTrading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29351);
// List of clevertap event for stockbit securities
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
// Clevertap event is wrapped with high order function
// to separate concern with existing code.








// Symbol type for clevertap is different from
// exisitng API response
function generateSymbolType(symbol) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(symbol.split("-"), 2), symbolType = ref[1];
    if (!symbolType) {
        return "Normal";
    }
    if (symbolType.toUpperCase()[0] === "R") {
        return "Right";
    }
    if (symbolType.toUpperCase()[0] === "W") {
        return "Warrant";
    }
    return "";
}
function clevertapOrderDetailCancel() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, symbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", orderType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Buy";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_SELECTED */ .Le, {
        Type: type,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_VIEWED */ .Tf);
}
function clevertapOrderDetailCancelConfirmed(param) {
    var symbol = param.symbol, orderType = param.orderType, expiry = param.expiry, leverage = param.leverage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_CONFIRMED */ .fR, {
        symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Expiry: expiry,
        "Leverage Type": leverage
    });
}
function clevertapOrderDetailAmend(param) {
    var _type = param.type, type = _type === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _type, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_AMEND_SELECTED */ .fg, {
        Type: type,
        symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapOrderDetailAmendViewed(param) {
    var symbol = param.symbol, orderType = param.orderType, type = param.type;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_VIEWED */ .z8, {
        Symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Type: type
    });
}
function clevertapOrderQuantityAdjusted(param) {
    var symbol = param.symbol, orderType = param.orderType, adjustedType = param.adjustedType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_QUANTITY_ADJUSTED */ .gW,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_QUANTITY_ADJUSTED */ .sR,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPlaced(param) {
    var orderType = param.orderType, symbol = param.symbol, price = param.price, lot = param.lot, gainLoss = param.gainLoss, totalLot = param.totalLot, tradingBalancePercentage = param.tradingBalancePercentage, status = param.status, expiry = param.expiry, type = param.type, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PLACED */ .gg,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "% Trading Balance": tradingBalancePercentage,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PLACED */ .vc,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "Gain/Loss %": gainLoss,
            "% Total Lot": totalLot,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPreviewed(param) {
    var symbol = param.symbol, orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PREVIEWED */ .L9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PREVIEWED */ .q7,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_PREVIEWED */ .jG,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderCanceled(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CANCELED */ .lE,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CANCELED */ .dT,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CANCELED */ .a,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmed(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED */ .ee,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED */ .ZF,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type,
            Expiry: expiry,
            "Balance Lot": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CONFIRMED */ .Dn,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmedSuccess(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderId = param.orderId, orderType = param.orderType, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry;
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (currentUrl.includes("symbol")) {
        if (currentUrl.includes("chartbit")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
        } else {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
        }
    } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
    } else if (currentUrl.includes("portfolio")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
    } else if (currentUrl.includes("watchlist")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
    }
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED_SUCCESS */ .p3,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED_SUCCESS */ .LD,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderReceived(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_RECEIVED */ .Hm,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_RECEIVED */ .n2,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderDone(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_DONE */ .g1,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_DONE */ .xc,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapExchangeFee(orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_SELECTED */ .tI);
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_VIEWED */ ._e, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
}
function clevertapChangeStock() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_STOCK_VIEWED */ .jr);
}
function clevertapBuyError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ERROR_PAGE */ .IU, {
        Reason: "Insufficient Trading Limit"
    });
}
function clevertapPortfolioSell(param) {
    var _tradingType = param.tradingType, tradingType = _tradingType === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _tradingType, source = param.source, gainLoss = param.gainLoss, symbol = param.symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SELL_STOCK_SELECTED */ .vf, {
        Type: tradingType,
        Source: source,
        "Gain/Loss %": gainLoss,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioCompanySell(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_COMPANY_SELL_STOCK_SELECTED */ .JW, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioBuyMore(symbol, gainLoss) {
    var tradingType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_BUY_MORE_SELECTED */ ._O, {
        Symbol: symbol,
        "Gain / Loss %": gainLoss,
        Type: tradingType
    });
}
function clevertapViewChartSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEW_CHART_SELECTED */ .J1, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapSetPriceAlertSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SET_PRICE_ALERT_SELECTED */ .ef, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapPortfolioViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, portfolioType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .PORTFOLIOS_TYPE.regular */ .ub.regular;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEWED */ .tA, {
        Type: tradingType,
        "Portfolio List": portfolioType
    });
}
function clevertapPortfolioOrderViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Order";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_ORDER_VIEWED */ .zF, {
        Type: tradingType,
        Filter: (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(filter)
    });
}
function clevertapOrderViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_VIEWED */ .dz);
}
function clevertapOrderDetailViewed(param) {
    var orderType = param.orderType, status = param.status, rejectReason = param.rejectReason, expiry = param.expiry, symbol = param.symbol, type = param.type, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _dayTradeForceSell = param.dayTradeForceSell, dayTradeForceSell = _dayTradeForceSell === void 0 ? false : _dayTradeForceSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_VIEWED */ .v9, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        Status: status,
        "Reject Reason": rejectReason,
        Expiry: expiry,
        Symbol: symbol,
        Type: type,
        "Symbol Type": generateSymbolType(symbol),
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": dayTradeForceSell ? "Force Sell" : "Regular"
    });
}
function clevertapStockSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_SELECTED */ .B);
}
function clevertapExerciseClicked(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_EXERCISE_CLICKED */ ._g, {
        Symbol: symbol
    });
}
function clevertapExerciseViewed(param) {
    var symbol = param.symbol, share = param.share;
    return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_VIEWED */ .dW, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share
    });
}
function clevertapExerciseSelected(param) {
    var symbol = param.symbol, share = param.share, stockOnHandPercentage = param.stockOnHandPercentage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_SELECTED */ .Nq, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share,
        "% Stock on Hand": stockOnHandPercentage
    });
}
function clevertapExerciseError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ERROR_PAGE */ .Vm, {
        Reason: "Melebihi Cash on Hand"
    });
}
function clevertapTransactionOrderFailed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED);
}
function clevertapTransactionOrderFailedConfirmed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED_CONFIRMED);
}
function clevertapTransactionOrderAlert() {
    clevertapEvent(TRANSACTION_ORDER_ALERT);
}
function clevertapBuyStockContinue() {
    clevertapEvent(BUY_STOCK_CONTINUE);
}
function clevertapPortfolioDetailViewed(param) {
    var symbol = param.symbol, gainLoss = param.gainLoss, exerciseable = param.exerciseable, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_STOCK_DETAIL_VIEWED */ .kC, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Gain/Loss %": gainLoss,
        Exercisable: exerciseable,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular"
    });
}
function clevertapPortfolioDetailExercise(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_DETAIL_EXERCISE_SELECTED */ .le, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapDayTradeActivationViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_VIEWED */ .jY);
}
function clevertapDayTradeTNCViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_TNC_VIEWED */ .hG);
}
function clevertapDayTradeActivationSuccessViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_VIEWED */ .DQ);
}
function clevertapDayTradeActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SELECTED */ .Av
    });
}
function clevertapDayTradeActivationDismissed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_DISMISSED */ .wK
    });
}
function clevertapDayTradeActivationSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUBMITTED */ .mX
    });
}
function clevertapDayTradeActivationSuccessSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_SELECTED */ .Go
    });
}
function clevertapDayTradeLeverageOptionViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_OPTION_VIEWED */ .zW);
}
function clevertapDayTradeLeverageActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED */ .TC
    });
}
function clevertapDayTradeAfterMarketViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_AFTER_MARKET_VIEWED */ .D1);
}
function clevertapDayTradeDebtRatioViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_VIEWED */ .nc);
}
function clevertapDayTradeDebtRatioSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED */ .Yu
    });
}
function clevertapDayTradeDebtRatioChipSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_CHIP_SELECTED */ .zt
    });
}
function clevertapDayTradeDebtRatioModalViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_MODAL_VIEWED */ .bK);
}
function clevertapDayTradeStockListViewed(param) {
    var _sourcePage = param.sourcePage, sourcePage = _sourcePage === void 0 ? "Company Page" : _sourcePage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_LIST_VIEWED */ .GK, {
        "Source Page": sourcePage
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_SORT_VIEWED */ .YM);
}
function clevertapDayTradeLeverageSelected(leverage) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7,
        Leverage: leverage
    });
}
function clevertapDayTradeSortSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_SELECTED */ .cc
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_APPLIED */ .Zy
    });
}
function clevertapDayTradeOrderTypeSelected(stock, orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_TYPE_SELECTED */ .YB,
        Stock: stock,
        "Buy Order Type": orderType
    });
}
function clevertapDayTradeSplitOrderSelected(toggle) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SPLIT_ORDER_SELECTED */ .CV,
        Toggle: toggle ? "On" : "Off"
    });
}
function clevertapDayTradeOrderDetailSelected(param) {
    var symbol = param.symbol, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _forcedSell = param.forcedSell, forcedSell = _forcedSell === void 0 ? false : _forcedSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_DETAIL_SELECTED */ .BY, {
        Symbol: symbol,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": forcedSell ? "Force Sell" : "Regular"
    });
}
function clevertapSecuritiesTradingPinViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_VIEWED */ .Hd);
}
function clevertapSecuritiesTradingPinSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_SUBMITTED */ .II, {
        Method: "PIN Input"
    });
}
function clevertapBuyOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_VIEWED */ .HA, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapSellOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_VIEWED */ .gE, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapAutoOrderOptionsViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_AUTO_ORDER_OPTIONS_VIEWED */ .YS);
}
function clevertapSetVisibleBalance() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SET_VISIBLE_BALANCE */ .G2);
}
function clevertapOrderTabSelected(tab) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Order Detail Action", {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_ORDER_TAB_SELECTED */ .Oc,
        "Transaction Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(tab)
    });
}


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page",
    chartbit: "Chartbit"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 29172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var SECTOR_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/emitten");
var getSectorList = function() {
    return request.get("".concat(SECTOR_API, "/sectors"));
};
var getSubsectorList = function(sectorId) {
    return request.get("".concat(SECTOR_API, "/sectors/").concat(sectorId, "/subsectors"));
};
var getCompanyList = function(sectorId, subSectorId) {
    return request.get("".concat(SECTOR_API, "/v3/sector/").concat(sectorId, "/subsector/").concat(subSectorId, "/company"));
};
var getCompanyInSector = function(sectorId) {
    return request.get("".concat(SECTOR_API, "/v3/sector/").concat(sectorId, "/company"));
};
var getSpecialBoardIndex = function() {
    return request.get("".concat(SECTOR_API, "/indexes/special-board"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSectorList: getSectorList,
    getSubsectorList: getSubsectorList,
    getCompanyList: getCompanyList,
    getCompanyInSector: getCompanyInSector,
    getSpecialBoardIndex: getSpecialBoardIndex
});


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ })

}]);